module.exports = __webpack_public_path__ + "static/media/sort-amount-down-alt.1def3c80.svg";